import React from 'react';

import DateTimeField from 'ui/form/date-field/date-time-field';
import { FormField } from 'ui/form/form-field';

import { TimeFieldProps } from 'ui/form/fields';

interface TimeFieldState {}
export default class DateField extends FormField<TimeFieldProps, TimeFieldState> {
  static get defaultValue() {
    return Date.now().getTime();
  }
  
  static getErrors(props: TimeFieldProps, formData) {
    return DateTimeField.getErrors(props, formData);
  }
  
  validate(onlyTouched: boolean) {
    return DateTimeField.validate(this.props);
  }

  render() {
    return <DateTimeField {...this.props} ref={ref => (this.dateTimeField = ref)} noDate />;
  }
}
